<template>
  <div>
    <modal
      size="small"
      v-if="visible"
      :show-controls="false"
      @close-modal="closeModal"
    >
      <div slot="header" class="col-md-12">
        Funções e Permissões
      </div>
      <div class="container" slot="content">
        <p>
          Saiba quais ações são permitidas para cada função na sua organização.
        </p>
        <div class="form-group">
          <table class="table table-striped">
            <tbody>
            <tr v-for="role in roles">
              <td> <b> {{role.nome}} </b></td>
              <td>
                <ul>
                  <li v-for="permission in role.permissions">{{permission}}</li>
                </ul>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div slot="footer">
      </div>
    </modal>
    <Loading></Loading>
  </div>
</template>

<script>
import Loading from "../monitoramentos/Loading.vue";

export default {
  name: "OrganizacaoRolesPermissoesModal",
  props: {
    visible: Boolean,
    roles: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
    };
  },
  components: {
    Loading
  },
  methods: {
    closeModal: function() {
      this.$emit("closeModal");
    },
  }
}
</script>

<style lang="stylus" scoped>
.mt
  margin-top 24px
.display-btn
  width 18%
.name-w
  width 80%
.token-field
  resize none
.name-field
  width 50%
.danger-background
  background-color #F44336
  border 1px solid #F44336
  .danger-background:hover,
  .danger-background:active,
  .danger-background:focus
    background-color #B50E02
    border-color #B50E02
.title
  font-size 16px
  margin-bottom 3px
.success-background
  background-color #4CAF50
  border 1px solid #4CAF50
.normal-background
  color #000
  background-color #fff
  border 1px solid #d1d5db
</style>
